import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';

import { isNil } from 'lodash';

import { OfficeStore } from '@pages/office/store/office.store';
import { ComboBoxItem } from '@pages/office/models/combobox-item.model';
import { OfficeFieldWebInputTypeEnum } from '@pages/office/models/office-data.model';
import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { BaseFormControlDirective } from '../base-form-control.directive';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';
import { ControlTypeEnum } from '../../../../models/control-type.model';
import { isEmptyValue } from '@core/helpers/value-empty-checker.helper';

@Component({
  selector: 'app-select',
  templateUrl: 'select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ControlWrapperComponent, ReactiveFormsModule, AsyncPipe, NgForOf, NgIf, ControlHasRequiredPipe],
})
export class SelectComponent extends BaseFormControlDirective implements OnInit {
  public comboBoxItems: ComboBoxItem[];

  readonly controlTypeEnum: typeof ControlTypeEnum = ControlTypeEnum;

  private officeStore = inject(OfficeStore);

  ngOnInit(): void {
    super.ngOnInit();
    this.comboBoxItems = this.officeStore.getComboboxBySeq(this.officeField.Seq);
    this.setDefaultValue();
    this.convertValueToString();
  }

  private convertValueToString(): void {
    !isNil(this.control.value) && this.control.setValue(String(this.control.value), { emitEvent: false, onlySelf: true });
  }

  private setDefaultValue(): void {
    if (this.officeField.WebInputType === OfficeFieldWebInputTypeEnum.radiobutton && isEmptyValue(this.control.value)) {
      const [firsOption] = this.comboBoxItems;
      this.control.setValue(firsOption.DatabaseValue, { emitEvent: true, onlySelf: true });
      this.control.markAsDirty();
    }
  }
}
